import { render, staticRenderFns } from "./PaginationCounter.vue?vue&type=template&id=9515f4f2&"
import script from "./PaginationCounter.vue?vue&type=script&lang=ts&"
export * from "./PaginationCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports